import React, { useState, useEffect, useRef } from "react";
import CalendarSideBarTicket from "./CalendarSideBarTicket";
import { ChevronDown, ChevronUp } from "lucide-react";

const CalendarSidebarticketGroup = ({ tickets, status }) => {
  const [isHide, setIsHide] = useState(false);
  const contentRef = useRef(null);

  const getSidebarTicketHeaderBgColor = (status) => {
    if (status === "Open") return "bg-[#FFF9BF]";
    else if (status === "Closed") return "bg-[#C5E9C6]";
    else if (status === "Scheduled") return "bg-[#BFD9FF]";
    else return "bg-gray-200";
  };

  useEffect(() => {
    const el = contentRef.current;
    if (!el) return;

    if (!isHide) {
      el.style.maxHeight = el.scrollHeight + "px";
      el.style.opacity = "1";
    } else {
      el.style.maxHeight = "0px";
      el.style.opacity = "0";
    }
  }, [isHide, tickets.length]);

  return (
    <>
      {tickets.length > 0 && (
        <div
          onClick={() => setIsHide((prev) => !prev)}
          className={`flex px-8 py-2 items-center justify-between cursor-pointer ${getSidebarTicketHeaderBgColor(
            status
          )}`}
        >
          <span className="text-[16px] font-semibold">{status}</span>
          {isHide ? (
            <ChevronDown className="w-8 h-4" />
          ) : (
            <ChevronUp className="w-8 h-4" />
          )}
        </div>
      )}
      <div
        ref={contentRef}
        className={`transition-all duration-300 ease-in-out ${
          isHide ? `overflow-y-hidden` : ``
        }`}
        style={{
          maxHeight: isHide ? "0px" : undefined, // will be set by effect
          opacity: isHide ? 0 : 1,
        }}
      >
        {tickets.map((ticket, i) => (
          <CalendarSideBarTicket key={i} ticket={ticket} status={status} />
        ))}
      </div>
    </>
  );
};

export default CalendarSidebarticketGroup;
